import type { AField } from '@/domain/field/AField';
import type { TUserContext } from '@/application/selection/TUserContext';

// Template content only. The cut shape never reaches here: it isn't editable at all, and
// CuttingShapeController decides what to draw for it on its own.
function computeIsEditable(entity: AField, ctx: TUserContext): boolean {
    if (!entity.isLocked) {
        return true;
    }
    return ctx.isAdmin;
}

export { computeIsEditable };
